import { Component } from '@angular/core'
import { ConfirmationService, MessageService } from 'primeng/api'

import { ApiChannelSourcesService } from '../data/services/api/api-channel-sources.service'
import { ChannelSourcesViewService } from '../data/services/view/channel-sources-view.service'
import { IChannelSource } from '../data/interfaces/channel-source.interface'
import { ITableCol } from '@data/interfaces/itable.interface'

@Component({
  selector: 'app-omnichannel-admin',
  templateUrl: './omnichannel-admin.component.html',
  styleUrls: ['./omnichannel-admin.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class OmnichannelAdminComponent {
  formVisible = false
  editing: IChannelSource | null = null

  columns: ITableCol[] = [
    { type: 'text', field: 'key', header: 'Clave' },
    { type: 'text', field: 'label', header: 'Etiqueta' },
    { type: 'text', field: 'category', header: 'Categoría' },
    { type: 'text', field: 'actorRoleRequired', header: 'Rol del actor' },
    { type: 'boolean', field: 'active', header: 'Activo', dataType: 'boolean' },
    { type: 'date', field: 'createdAt', header: 'Creado', dataType: 'date' },
  ]

  actions = [
    { icon: 'fa-solid fa-pen', color: 'info', action: 'edit', title: 'Editar', permission: ['omnichannel', 'update'] as [string, string] },
    { icon: 'fa-solid fa-trash', color: 'danger', action: 'delete', title: 'Desactivar', permission: ['omnichannel', 'delete'] as [string, string] },
  ]

  //* "Nuevo canal" vive dentro del menú "Acciones" de la tabla (convención del resto de tablas),
  //* no como botón suelto. La página ya está gateada por omnichannel:create (route data).
  additionalMainActions = [{ label: 'Nuevo canal', icon: 'fa-solid fa-plus', action: 'CREATE' }]

  constructor(public apiService: ApiChannelSourcesService, private viewService: ChannelSourcesViewService, private confirmation: ConfirmationService) {}

  onAction(event: { action: string; data: IChannelSource }): void {
    if (event.action === 'edit') this.openEdit(event.data)
    else if (event.action === 'delete') this.confirmDelete(event.data)
  }

  onMainAction(action: string): void {
    if (action === 'CREATE') this.openCreate()
  }

  openCreate(): void {
    this.editing = null
    this.formVisible = true
  }

  openEdit(source: IChannelSource): void {
    this.editing = source
    this.formVisible = true
  }

  confirmDelete(source: IChannelSource): void {
    this.confirmation.confirm({
      message: `¿Desactivar el canal "${source.label}"?`,
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.viewService.remove(source._id).subscribe(),
    })
  }

  onSaved(): void {
    this.formVisible = false
  }
}
